import {format} from 'date-fns'

import {parseApiDate} from '../jobs/job-schedule-format'
import {formatCadenceWeekdays} from '../service-schedules/schedule-draft-logic'

export function formatScheduleWindowLabel(startDate: string, endDate: string): string {
    const startLabel = format(parseApiDate(startDate), 'MMM d')
    const endLabel = format(parseApiDate(endDate), 'MMM d, yyyy')
    return `${startLabel} – ${endLabel}`
}

export function formatScheduleCadenceLabel(cadenceWeekdays: number[]): string {
    return formatCadenceWeekdays(cadenceWeekdays)
}

/**
 * Footer line for the schedules directory: how much of the project's job list a
 * schedule actually accounts for, and how many jobs are standing on their own.
 */
export function formatScheduleCoverageLabel(
    totalJobCount: number,
    scheduledJobCount: number,
): string {
    const oneOffCount = totalJobCount - scheduledJobCount

    if (oneOffCount <= 0) {
        const verb = totalJobCount === 1 ? 'comes' : 'come'
        return `All ${totalJobCount} ${totalJobCount === 1 ? 'job' : 'jobs'} ${verb} from a schedule`
    }

    const oneOffLabel = oneOffCount === 1 ? "job isn't" : "jobs aren't"
    return `${scheduledJobCount} of ${totalJobCount} jobs come from a schedule · ${oneOffCount} one-off ${oneOffLabel} on one`
}
